export default __webpack_public_path__ + "static/media/805.79880928.png";